import { track } from '../utils/analytics'

// Public phrasebook pages are plain ERB (no Vue) — wire up the audio play
// buttons and CTA funnel tracking with delegated listeners, mirroring
// landing.js but with phrasebook-specific events. Uses data-pb-* attributes
// (not data-cta-destination) so mountLanding doesn't also bind here and
// double-count clicks.
let bound = false

export function mountPhrasebook() {
  if (bound || !document.querySelector('[data-pb-cta], [data-pb-slug]')) return
  bound = true

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-play-audio]')
    if (button) {
      try {
        const rate = parseFloat(button.dataset.audioRate || '1')
        const audio = new Audio(button.dataset.playAudio)
        if (rate !== 1) {
          audio.playbackRate = rate
          // Preserve pitch so the tones survive the slowdown (webkit- spelling
          // for older Safari), matching AudioButton's turtle.
          audio.preservesPitch = true
          audio.webkitPreservesPitch = true
        }
        audio.play().catch(() => {})
        track('phrasebook_audio_played', { slug: button.dataset.pbSlug || null, rate })
      } catch (_e) {
        // Missing/blocked audio should never break the page.
      }
      return
    }

    const cta = event.target.closest('[data-pb-cta]')
    if (cta) {
      track('phrasebook_cta_clicked', {
        destination: cta.dataset.pbCta,               // demo | signup
        location: cta.dataset.pbLocation || 'unknown', // nav | word_page | index_footer
      })
    }
  })
}
